import _jsx from "@babel/runtime/helpers/jsx";
import React, { useState, useCallback } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { CloseButton, Text, Glyphicon, AccessibilityUtilities, Link } from 'reaxl';
import { DelayedImpressionObserver } from 'reaxl-analytics';
function HeaderSlidingMenu(_ref) {
  let {
    navItems = [],
    sponsoredContent = [],
    getSponsoredContent,
    onClick,
    onSponsorContentReady = () => {},
    isSlidingMenuOpen,
    handleSlidingMenuClose
  } = _ref;
  const [isSlidingMenuAccordionOpen, setIsSlidingMenuAccordionOpen] = useState(false);
  const handleDelayedImpression = useCallback(e => {
    sponsoredContent.forEach(sponsor => {
      if (sponsor.sponsoredText) {
        onSponsorContentReady(e, sponsor);
      }
    });
  }, [sponsoredContent, onSponsorContentReady]);
  const onClose = () => {
    handleSlidingMenuClose();
    setIsSlidingMenuAccordionOpen(false); // always reset accordion to closed state
  };
  const toggleSlidingMenuAccordion = () => {
    setIsSlidingMenuAccordionOpen(prevState => !prevState);
  };
  const renderSlidingMenuAccordionLinks = subNavItem => {
    const handleAccordionLinkClick = e => {
      onClick(e, subNavItem);
    };
    return /*#__PURE__*/_jsx("div", {}, subNavItem.text, /*#__PURE__*/_jsx(Text, {
      componentClass: "div",
      className: "sliding-menu-accordion-title margin-bottom-3",
      size: 100,
      weight: "bold"
    }, void 0, subNavItem.text), /*#__PURE__*/_jsx("ul", {
      className: "sliding-menu-accordion-links padding-bottom-4"
    }, void 0, subNavItem.items.map(item => /*#__PURE__*/_jsx("li", {
      className: "margin-bottom-4"
    }, item.eventkey, /*#__PURE__*/_jsx(Link, {
      onClick: handleAccordionLinkClick,
      href: item.href
    }, void 0, /*#__PURE__*/_jsx(Text, {
      transformCase: "capitalize",
      weight: "normal",
      size: 300
    }, void 0, item.text))))));
  };
  const renderSlidingMenuLinks = (navItem, index) => {
    const {
      eventkey,
      href,
      text,
      glyph,
      items
    } = navItem;
    const isSlidingMenu = true;
    const isLastItem = index === navItems.length - 1;
    const handleSlidingMenuLinkClick = e => {
      onClick(e, navItem);
    };

    // sub menu nav links
    if (items) {
      return /*#__PURE__*/_jsx("li", {
        "data-cmp": "slidingMenuLink",
        className: "sliding-menu-accordion-panel"
      }, `${text}-${eventkey}`, /*#__PURE__*/_jsx("button", {
        className: "display-flex align-items-center gap-3",
        onClick: toggleSlidingMenuAccordion,
        "aria-expanded": isSlidingMenuAccordionOpen,
        onKeyDown: () => AccessibilityUtilities.withKeyboardAccessibility(toggleSlidingMenuAccordion),
        type: "button",
        "data-cmp": "slidingMenuAccordionButton"
      }, void 0, /*#__PURE__*/_jsx(Glyphicon, {
        glyph: glyph,
        className: "text-size-500"
      }), /*#__PURE__*/_jsx(Text, {
        transformCase: "capitalize",
        size: 400,
        weight: "normal"
      }, void 0, text), /*#__PURE__*/_jsx(Glyphicon, {
        glyph: isSlidingMenuAccordionOpen ? 'menu-up' : 'menu-down',
        className: "text-size-650 margin-left-auto accordion-panel-menu-icon"
      })), /*#__PURE__*/_jsx("div", {
        className: clsx(isSlidingMenuAccordionOpen && 'open', 'sliding-menu-accordion-panel-content')
      }, void 0, isSlidingMenuAccordionOpen && /*#__PURE__*/_jsx(DelayedImpressionObserver, {
        onChange: handleDelayedImpression
      }, "sponsored-content-delayed-impression", items.map(subNavItem => renderSlidingMenuAccordionLinks(subNavItem)), sponsoredContent.length > 0 && /*#__PURE__*/_jsx("div", {
        className: "margin-bottom-4 sliding-menu-sponsored-content"
      }, void 0, getSponsoredContent(sponsoredContent, onClick, isSlidingMenu)))));
    }

    // top level header links
    return /*#__PURE__*/_jsx("li", {
      "data-cmp": "slidingMenuLink"
    }, `${text}-${eventkey}`, /*#__PURE__*/React.createElement(Link, Object.assign({
      className: "display-flex align-items-center gap-3",
      href: href,
      onClick: handleSlidingMenuLinkClick
      // for accessibility - ensure the sliding menu is closed when user tabs out of its contents
    }, isLastItem && {
      onBlur: onClose
    }), /*#__PURE__*/_jsx(Glyphicon, {
      glyph: glyph,
      className: "text-size-500"
    }), /*#__PURE__*/_jsx(Text, {
      transformCase: "capitalize",
      size: 400,
      weight: "normal"
    }, void 0, text)));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx("div", {
    "aria-hidden": "true",
    "data-cmp": "slidingMenuOverlay",
    className: clsx(isSlidingMenuOpen && 'open', 'sliding-menu-overlay'),
    onClick: onClose
  }), /*#__PURE__*/_jsx("div", {
    "data-cmp": "slidingMenu",
    className: clsx(isSlidingMenuOpen && 'open', 'sliding-menu slide-from-left')
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "sliding-menu-header display-flex justify-content-end padding-4"
  }, void 0, /*#__PURE__*/_jsx(CloseButton, {
    onClick: onClose
  })), /*#__PURE__*/_jsx("nav", {
    "data-cmp": "headerMobileNav",
    className: "sliding-menu-container margin-top-4 padding-horizontal-5"
  }, void 0, /*#__PURE__*/_jsx("ul", {
    className: "sliding-menu-links"
  }, void 0, navItems.map((navItem, index) => renderSlidingMenuLinks(navItem, index))))));
}
export default HeaderSlidingMenu;